import React from 'react';
import { RouteProps } from 'react-router-dom';
import { LayoutRouteProps } from './LayoutRoute';
import { LayoutRoute } from './LayoutRoute';

export const AdminRoute: React.FC<RouteProps & LayoutRouteProps> = (props) => <LayoutRoute {...props} privateRoute adminRoute />;
